import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faqs-content-${index}`}
      aria-labelledby={`faqs-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `faqs-${index}`,
//     'aria-controls': `faqs-${index}`,
//   };
// }

const FAQs = () => {
  const [value, setValue] = useState(4);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="FAQs for E-filing IRS Form 990 Online with TaxZerone®"
          description="Leverage the Knowledge Base and FAQ on TaxZerone for seamless e-filing of IRS Form 990"
          keywords=""
          canonical="faqs/form-990/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">FAQs - Form 990</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
              id="general"
            >
              Here are some common questions you may have about Form 990
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="flex-start"
            spacing={2}
          >
            <Hidden smDown>
              <Box
                sx={{
                  maxWidth: 180,
                  position: 'sticky',
                  top: 90,
                  border: '1px solid #ccc',
                  mt: '24px !important',
                  borderRadius: 2,
                  boxShadow: '0 0 10px rgba(0,0,0,.10)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  orientation="vertical"
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    py: 1,
                  }}
                  className="faq-container"
                >
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          General
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      //  color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 2290
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{
                              width: 12,
                              height: 12,
                              marginRight: 4,
                              marginTop: 3,
                            }}
                          />
                          Form 2290 Amendments
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8849
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-EZ
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-N
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 941
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-941/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 7004
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 4868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 15397
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box
                sx={{
                  position: 'sticky',
                  top: 62,
                  backgroundColor: '#213e99',
                  zIndex: 1,
                  width: '100%',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fill: '#fff' },
                    maxWidth: 380,
                    mt: '2px',
                  }}
                  className="faq-container"
                >
                  <Tab
                    label="General"
                    // {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label="Form 2290"
                    //  {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label="Form 2290 Amendments"
                    //  {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label="Form 8849"
                    //  {...a11yProps(3)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label="Form 990-N"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label="Form 7004"
                    //  {...a11yProps(5)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label="Form 4868"
                    //  {...a11yProps(6)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label="Form 8868"
                    //  {...a11yProps(7)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label="Form 15397"
                    //  {...a11yProps(8)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }} />
              </Box>{' '}
            </Hidden>
            <Box
              sx={{
                width: '100%',
                pt: { sm: '8px !important' },
                px: { xs: 2, sm: 0 },
              }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <TabPanel>
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: 18, sm: 20, md: 24, lg: 30 },
                    fontWeight: 600,
                  }}
                >
                  Form 990
                </Typography> */}
                <Grid container spacing={0} rowSpacing={2} m={0} mt={0}>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        When is Form 990 due?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          The{' '}
                          <Link
                            href="/resources/tax-exempt/form-990-due-dates/"
                            sx={{ color: '#0202ff' }}
                          >
                            due date for filing IRS Form 990
                          </Link>{' '}
                          is generally the{' '}
                          <span style={{ fontWeight: 600 }}>
                            15th day of the fifth month
                          </span>{' '}
                          following the conclusion of an organization’s fiscal
                          year. For organizations that follow a calendar year,
                          this means that the form must be submitted by{' '}
                          <span style={{ fontWeight: 600 }}>May 15th</span>.
                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{
                              mt: 2,
                              borderLeft: '3px solid rgb(102, 60, 0)',
                            }}
                          >
                            <b>Note:</b> If the due date falls on a Saturday,
                            Sunday, or a legal holiday, file the form on the
                            next business day.
                          </Alert>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Which Form 990 must I file?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          The gross receipt of your tax-exempt organization
                          determines which{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form 990
                          </Link>{' '}
                          you must file.
                          <ul>
                            <li style={{ marginBottom: 12 }}>
                              File{' '}
                              <Link
                                href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=faq`}
                                sx={{ color: '#0202ff', fontWeight: 600 }}
                              >
                                Form 990-N
                              </Link>{' '}
                              (e-Postcard) if your organization&apos;s gross
                              receipts are normally{' '}
                              <span style={{ fontWeight: 600 }}>
                                $50,000 or less
                              </span>
                              .
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              File{' '}
                              <Link
                                href="/tax-exempt/e-file-irs-form-990-ez/"
                                sx={{ color: '#0202ff', fontWeight: 600 }}
                              >
                                Form 990-EZ
                              </Link>{' '}
                              if your organization&apos;s{' '}
                              <span style={{ fontWeight: 600 }}>
                                gross receipts
                              </span>{' '}
                              are{' '}
                              <span style={{ fontWeight: 600 }}>
                                less than $200,000
                              </span>{' '}
                              and{' '}
                              <span style={{ fontWeight: 600 }}>
                                total assets
                              </span>{' '}
                              are{' '}
                              <span style={{ fontWeight: 600 }}>
                                less than $500,000
                              </span>
                              .
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              File{' '}
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff', fontWeight: 600 }}
                              >
                                Form 990
                              </Link>{' '}
                              if your organization&apos;s{' '}
                              <span style={{ fontWeight: 600 }}>
                                gross receipts
                              </span>{' '}
                              are{' '}
                              <span style={{ fontWeight: 600 }}>
                                $200,000 or more
                              </span>
                              , or its{' '}
                              <span style={{ fontWeight: 600 }}>
                                total assets
                              </span>{' '}
                              are{' '}
                              <span style={{ fontWeight: 600 }}>
                                $500,000 or more
                              </span>{' '}
                              at the end of the tax year.
                            </li>
                            <li>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990-pf/"
                                sx={{ color: '#0202ff', fontWeight: 600 }}
                              >
                                Form 990-PF
                              </Link>{' '}
                              - Private foundations, regardless of their
                              financial size, must file Form 990-PF to report
                              their financial activities and grant-making
                              activities.
                            </li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Is there a penalty for not filing Form 990?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Typography sx={{ mb: 2 }}>
                            Yes. An exempt organization that files{' '}
                            <Link
                              href="/tax-exempt/e-file-irs-form-990/"
                              sx={{ color: '#0202ff' }}
                            >
                              IRS Form 990
                            </Link>{' '}
                            after the deadline without reasonable cause may be
                            subject to penalties imposed by the Internal Revenue
                            Service.
                          </Typography>

                          <Box component="div" sx={{ mt: 1, mb: 1.5 }}>
                            <TableContainer
                              sx={{
                                border: '1px solid #828282',
                                borderRadius: 2,
                              }}
                            >
                              <Table aria-label="Form 990 Penalty Chart">
                                <TableHead>
                                  <TableRow sx={{ backgroundColor: '#ccc' }}>
                                    <TableCell
                                      sx={{
                                        color: '#444',
                                        width: 220,
                                        borderRight: '1px solid #828282',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                      }}
                                    >
                                      Organization Size
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        color: '#444',
                                        width: 180,
                                        borderRight: '1px solid #828282',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                      }}
                                    >
                                      Penalty Per Day
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        color: '#444',
                                        width: 220,
                                        fontWeight: 600,
                                        textAlign: 'center',
                                      }}
                                    >
                                      Maximum Penalty
                                    </TableCell>
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        textAlign: 'center',
                                        borderRight: '1px solid #828282',
                                      }}
                                    >
                                      Gross receipts ≤{' '}
                                      <span style={{ fontWeight: 600 }}>
                                        $1,309,500
                                      </span>
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        textAlign: 'center',
                                        borderRight: '1px solid #828282',
                                      }}
                                    >
                                      <span style={{ fontWeight: 600 }}>
                                        $25
                                      </span>{' '}
                                      per day
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'center' }}>
                                      Lesser of{' '}
                                      <span style={{ fontWeight: 600 }}>
                                        $13,000
                                      </span>{' '}
                                      or{' '}
                                      <span style={{ fontWeight: 600 }}>
                                        5% of gross receipts
                                      </span>
                                    </TableCell>
                                  </TableRow>

                                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                                    <TableCell
                                      sx={{
                                        textAlign: 'center',
                                        borderRight: '1px solid #828282',
                                      }}
                                    >
                                      Gross receipts {'>'}{' '}
                                      <span style={{ fontWeight: 600 }}>
                                        $1,309,500
                                      </span>
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        textAlign: 'center',
                                        borderRight: '1px solid #828282',
                                      }}
                                    >
                                      <span style={{ fontWeight: 600 }}>
                                        $130
                                      </span>{' '}
                                      per day
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'center' }}>
                                      <span style={{ fontWeight: 600 }}>
                                        $65,000
                                      </span>{' '}
                                      per return
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>

                          <Typography sx={{ mb: 2 }}>
                            The penalty applies for each day the return remains
                            unfiled after the due date unless the organization
                            can demonstrate{' '}
                            <span style={{ fontWeight: 600 }}>
                              reasonable cause
                            </span>{' '}
                            for the delay. If you need more information about
                            penalties, you can refer to our{' '}
                            <Link
                              href="/resources/tax-exempt/form-990-penalties/"
                              sx={{ color: '#0202ff' }}
                            >
                              990 penalty instructions page
                            </Link>{' '}
                            for detailed guidance.
                          </Typography>

                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{
                              mt: 2,
                              borderLeft: '3px solid rgb(102, 60, 0)',
                            }}
                          >
                            <b>Note:</b> If a tax-exempt organization fails to
                            file Form 990 for three consecutive years, the
                            tax-exempt status of the organization will be
                            automatically revoked.
                          </Alert>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Is Form 990 subject to public inspection and disclosure?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Typography sx={{ mb: 2 }}>
                            Yes,{' '}
                            <Link
                              href="/tax-exempt/e-file-irs-form-990/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 990
                            </Link>{' '}
                            is a public document that is subject to public
                            inspection and disclosure. Anyone can request a copy
                            from the IRS or access it through various online
                            databases, such as <b>Guidestar</b>&nbsp;or the
                            organization&apos;s website.
                          </Typography>
                          <Typography sx={{ mb: 0 }}>
                            Additionally, the IRS makes these forms available to
                            the public on its website.
                          </Typography>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is unrelated business income?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          An <b>unrelated business gross income</b> is an income
                          received by an exempt organization through activities
                          unrelated to scientific, educational, charitable, or
                          any other tax-exempt purposes.
                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{
                              mt: 2,
                              borderLeft: '3px solid rgb(102, 60, 0)',
                            }}
                          >
                            <b>Note:</b> Organizations with{' '}
                            <b>$1,000 or more</b> for the tax year of total
                            gross income from all unrelated trades or businesses
                            must complete and file{' '}
                            <Link
                              href="/tax-exempt/e-file-irs-form-990-t/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 990-T
                            </Link>
                            .
                          </Alert>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How can I know my organization&apos;s exempt status?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          To verify your organization&apos;s tax-exempt status,
                          you can use the IRS{' '}
                          <Link
                            href={`${process.env.NEXT_PUBLIC_990FINDER_SITE_URL}?ref=faqs`}
                            sx={{ color: '#0202ff' }}
                          >
                            Tax Exempt Organization
                          </Link>{' '}
                          Search tool. This tool provides information about the
                          organization&apos;s federal tax status and filings in
                          an easy-to-access format.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is the purpose of Schedule A in Form 990?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography variant="body1" component="div">
                            <Link
                              href="/resources/tax-exempt/form-990-schedule-a/"
                              sx={{ color: '#0202ff', fontWeight: 600 }}
                            >
                              Schedule A
                            </Link>
                            , Public Charity Status and Public Support is to
                            provide the IRS with required information about
                            public charity status and public support and to
                            determine whether the exempt organization qualifies
                            as a public charity under Section 501(c)(3) of the
                            Internal Revenue Code.
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        I need to amend my Form 990. What to do?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Typography sx={{ mb: 2 }}>
                            To amend your organization&apos;s previously filed{' '}
                            <Link
                              href="/tax-exempt/e-file-irs-form-990/"
                              sx={{ color: '#0202ff' }}
                            >
                              990 return
                            </Link>
                            , file a new return providing all the information
                            and not just the new or corrected information. Also,
                            check the “<b>Amended return</b>” box in Item B
                            indicating you&apos;re filing an amended return.
                          </Typography>
                          <Typography sx={{ mb: 0 }}>
                            You can amend all the information in your original
                            Form 990 return except the organization&apos;s EIN.
                          </Typography>
                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{
                              mt: 2,
                              borderLeft: '3px solid rgb(102, 60, 0)',
                            }}
                          >
                            <b>Note:</b> To amend your 990 form, the IRS should
                            have accepted the previously filed return.
                          </Alert>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What to do if I can&apos;t meet my 990 deadline?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                        id="form990n"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          If you can&apos;t file your{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990/"
                            sx={{ color: '#0202ff' }}
                          >
                            990 form
                          </Link>{' '}
                          on or before the deadline, simply file{' '}
                          <Link
                            href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                            sx={{ color: '#0202ff' }}
                          >
                            form 8868
                          </Link>
                          , Application for Extension of Time to File an Exempt
                          Organization Return and obtain an automatic{' '}
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            six-month extension
                          </span>{' '}
                          to file your 990 returns.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Is IRS Form 990 searchable online?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                        id="form990n"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          Yes,
                          <Link
                            href="/tax-exempt/e-file-irs-form-990/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            IRS Form 990
                          </Link>{' '}
                          is searchable online. As it is a public record filed
                          with the Internal Revenue Service (IRS) by nonprofits,
                          most filings by the are available for the general
                          public to view.
                          <Typography variant="body1" sx={{ mt: 1 }}>
                            In other words, you can search for the nonprofit’s
                            Form 990 by entering their name or the EIN number
                            through{' '}
                            <Link
                              href={`${process.env.NEXT_PUBLIC_990FINDER_SITE_URL}?ref=faqs`}
                              sx={{ color: '#0202ff' }}
                            >
                              EIN Finder
                            </Link>{' '}
                            and viewing important information such as their
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              finances, activities, and previous filings
                            </span>
                            .
                          </Typography>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is Form 990 lookup used for?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                        id="form990n"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Link
                            href="/resources/tax-exempt/form-990-instructions/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            Form 990 lookup
                          </Link>{' '}
                          can help you determine whether the nonprofit qualifies
                          for their tax exemption status, reliability, and their
                          general activities. This is because Form 990 is filed
                          with the IRS where all the needed information is
                          consolidated.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is Form 990 search?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                        id="form990n"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Link
                            href="/resources/tax-exempt/form-990-instructions/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            Form 990 search
                          </Link>{' '}
                          refers to looking up the nonprofit's filing online.
                          This allows you to find their tax filing records with
                          the Internal Revenue Service through details including
                          the organization’s name or EIN number.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How do I perform an IRS Form 990 search?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                        id="form990n"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          To perform a Form 990 search, you can go to the online
                          database of IRS website or the trusted lookup tool
                          like{' '}
                          <Link
                            href={`${process.env.NEXT_PUBLIC_990FINDER_SITE_URL}?ref=faqs`}
                            sx={{ color: '#0202ff' }}
                          >
                            EIN Finder
                          </Link>
                          . Type in the organization's name or EIN number in
                          order to find their records.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to simplify your complex tax filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Choose TaxZerone and file IRS tax forms online in easy steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default FAQs;
